//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "BrowserNotRecommendedOverlay",
  data() {
    return {
      dismiss: false
    };
  },
  methods: {
    handleDismiss() {
      this.dismiss = true;
    }
  }
});